/**
 * Stock status labels: In Stock / Low Stock / Out of Stock.
 * Rule: quantity 10 or more = In Stock, 1 to 9 = Low Stock, 0 or sold out = Out of Stock.
 * Change LOW_STOCK_LIMIT to adjust the threshold.
 */
(function () {
  var LOW_STOCK_LIMIT = 10;
  var SELECTOR = '.product-form__inventory, .product-item__inventory';

  function statusFor(text) {
    var t = (text || '').trim();
    if (/sold out/i.test(t)) return 'out';
    var match = t.match(/(-?\d+)/);
    if (!match) return null; // not a stock count (e.g. backorder message): leave untouched
    var qty = parseInt(match[1], 10);
    if (qty <= 0) return 'out';
    return qty < LOW_STOCK_LIMIT ? 'low' : 'in';
  }

  var LABELS = { 'in': 'In Stock', 'low': 'Low Stock', 'out': 'Out of Stock' };

  function applyStatus(el) {
    var status = statusFor(el.textContent);
    if (!status) return;
    var label = LABELS[status];
    if (el.textContent.trim() !== label) {
      el.textContent = label;
    }
    el.classList.remove('inventory--low', 'inventory--high');
    if (status === 'low') el.classList.add('inventory--low');
    if (status === 'in') el.classList.add('inventory--high');
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) applyStatus(els[i]);
  }

  function init() {
    applyAll(document);
    // Re-apply when the theme updates stock text, e.g. after a variant change.
    var observer = new MutationObserver(function () { applyAll(document); });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
